__turbopack_context__.v({
  "bottomTextContainer": "styles-module-scss-module__NCXZfa__bottomTextContainer",
  "carouselContainer": "styles-module-scss-module__NCXZfa__carouselContainer",
  "itemContainer": "styles-module-scss-module__NCXZfa__itemContainer",
  "knockout": "styles-module-scss-module__NCXZfa__knockout",
  "titleContainer": "styles-module-scss-module__NCXZfa__titleContainer",
  "topTextContainer": "styles-module-scss-module__NCXZfa__topTextContainer",
});
